'use strict';

var _invariants = require('./utils/invariants');

var _injection = require('./injection');

var _instantiateReactComponent = require('react/lib/instantiateReactComponent');

var _instantiateReactComponent2 = _interopRequireDefault(_instantiateReactComponent);

var _ReactInstanceHandles = require('react/lib/ReactInstanceHandles');

var _ReactInstanceHandles2 = _interopRequireDefault(_ReactInstanceHandles);

var _ReactUpdates = require('react/lib/ReactUpdates');

var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);

var _ReactKonsulIDOperations = require('./ReactKonsulIDOperations');

var _ReactKonsulIDOperations2 = _interopRequireDefault(_ReactKonsulIDOperations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _injection.inject)();

var render = function render(nextElement, konsul, callback) {
  (0, _invariants.isValidElement)(nextElement);

  _ReactKonsulIDOperations2.default.setKonsul(konsul);

  var rootId = _ReactInstanceHandles2.default.createReactRootID(0);
  _ReactKonsulIDOperations2.default.add(rootId, konsul);
  var component = (0, _instantiateReactComponent2.default)(nextElement);

  _ReactUpdates2.default.batchedUpdates(function () {
    var transaction = _ReactUpdates2.default.ReactReconcileTransaction.getPooled();
    transaction.perform(function () {
      component.mountComponent(transaction, rootId, { _idCounter: 0 }, {});
    });
    _ReactUpdates2.default.ReactReconcileTransaction.release(transaction);
  });

  konsul.render();
};

module.exports = render;


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/index.js
// module id = 680
// module chunks = 0